module.exports = __webpack_public_path__ + "img/P3.77603e2.png";